<div class="container" role="region" [attr.aria-label]="'About Me section' | translate: {Default: 'About Me section'}">
  <div class="left" role="complementary" [attr.aria-label]="'Employee profile summary' | translate: {Default: 'Employee profile summary'}">
    <app-photo-and-details></app-photo-and-details>
  </div>

  <div class="right" role="region" aria-labelledby="about-me-accordion-title" aria-describedby="about-me-accordion-help">
    <h2 id="about-me-accordion-title" class="sr-only">{{ 'AboutMeDetails' | translate: {Default: 'About me details'} }}</h2>
    <p id="about-me-accordion-help" class="sr-only">{{ 'Use Enter or Space to expand and collapse sections.' | translate: {Default: 'Use Enter or Space to expand and collapse sections.'} }}</p>

    <mat-accordion [attr.aria-label]="'About me details sections' | translate: {Default: 'About me details sections'}">
      <mat-expansion-panel *appHasFeature="features.TAB_PERSONAL_DETAILS" togglePosition="before">
          <mat-expansion-panel-header>
            <h3>{{ 'PersonalDetails' | translate: {Default: "Personal Details"} }}</h3>
          </mat-expansion-panel-header>
        
          <ng-template matExpansionPanelContent>
            <app-personal-details-form [employeeId]="user$.userId" [showTitle]="false"></app-personal-details-form>
          </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel *appHasFeature="features.TAB_EMERGENCY_CONTACTS" togglePosition="before">
          <mat-expansion-panel-header>
            <h3>{{ 'EmergencyContacts' | translate: {Default: "Emergency Contacts"} }}</h3>
          </mat-expansion-panel-header>
        
          <ng-template matExpansionPanelContent>
            <app-emergency-contacts [employeeID]="user$.userId" [showTitle]="false"></app-emergency-contacts>
          </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel *appHasFeature="features.TAB_FAMILY_DEPENDANTS" togglePosition="before">
        <mat-expansion-panel-header>
          <h3>{{ 'FamilyDependants' | translate: {Default: "Family Dependants"} }}</h3>
        </mat-expansion-panel-header>
      
        <ng-template matExpansionPanelContent>
          <app-employee-family-dependants [employeeID]="user$.userId" [showTitle]="false"></app-employee-family-dependants>
        </ng-template>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</div>